import { createSelector } from 'reselect'

const selectEntities = (state) => {
    return state.address.entities
}
const selectResult = (state) => state.address.result

export const selectAll = createSelector(
  [selectEntities, selectResult],
  (entities, result) => result.map((id) => entities[id]),
)

export const selectOne = (state, props) => state.address.entities[props.id]
